<template>
  <div>
    <a-modal title="关联需求" width="880px" :visible="visible" @cancel="visible = false" @ok="onSubmit">
      <a-form-model layout="inline" :model="filterForm" class="filter-form">
        <a-form-model-item label="需求标题">
          <a-input v-model="filterForm.title" placeholder="需求标题筛选" @change="onSearch" />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="onSearch"> 查询 </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-table size="small" :expand-icon-column-index="2" :row-selection="showRowSelection" :columns="columns" :data-source="tableData" row-key="id" :pagination="pagination" :loading="loading" :expanded-row-keys.sync="expandedRowKeys" @change="handleTableChange">
        <span slot="customerTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a class="custom-link" :href="requirementLink(record)" target="_blank"> {{ record.title }} </a>
          </a-tooltip>
        </span>
        <span slot="type" slot-scope="text, record">
          <a-badge v-if="record.requirement_type" :color="storyTypes[record.requirement_type].color" :text="storyTypes[record.requirement_type].label" />
        </span>
      </a-table>
    </a-modal>
    <a v-tc="{ name: '关联需求' }" class="case-requirement-relation" @click="onRelation"><a-icon type="search" /> 关联需求</a>
  </div>
</template>
<script>
import { storyTypes } from '@/utils/dictionary';
import { storyTree } from '@/api/project/story';
import { caseRequirementRelation } from '@/api/project/case';
const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 80
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
    scopedSlots: { customRender: 'customerTitle' }
  },
  {
    title: '类型',
    align: 'center',
    dataIndex: 'type',
    key: 'type',
    width: 120,
    scopedSlots: { customRender: 'type' }
  }
];
export default {
  props: {
    caseId: {
      type: [String, Number],
      default: null
    },
    dataSource: {
      type: [Array, String],
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      storyTypes,
      loading: false,
      visible: false,
      tableData: [],
      selectedRowKeys: [],
      filterForm: {
        title: null
      },
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      expandedRowKeys: [],
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  computed: {
    requirementLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: record.id }
        });
        return route.href;
      };
    },
    showRowSelection() {
      return { selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange };
    }
  },
  methods: {
    onRelation() {
      this.visible = true;
      this.filterForm = {
        title: null
      };
      this.getRequirementData();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onSearch() {
      this.utils.trackClick({ name: '搜索需求' });
      this.pagination.current = 1;
      this.getRequirementData();
    },
    getRequirementData() {
      this.loading = true;
      storyTree({ ...this.filterForm, project_id: this.projectId, page_size: this.pagination.pageSize, page_number: this.pagination.current || 1 })
        .then(res => {
          this.tableData = res.data.items;
          this.expandedRowKeys = res.data.requirement_ids;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getRequirementData();
    },
    onSubmit() {
      caseRequirementRelation({ id: this.caseId, project_id: this.projectId, requirements: this.selectedRowKeys }).then(() => {
        this.visible = false;
        this.selectedRowKeys = [];
        this.$emit('reload');
      });
    }
  }
};
</script>
<style lang="less" scoped>
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
.case-requirement-relation {
  line-height: 32px;
}
.filter-form {
  margin-bottom: 8px;
}
</style>
